export default {
  AtWill: null,
  SpellSlot: 'SP',
  Ki: 'Ki',
};
